import { CheckboxField } from 'cwp-components/forms'

type OfficeListProps = {
  selected: Array<string>
  setSelected: any
}

export const OffliceList = ({
  selected,
  setSelected,
  ...props
}: OfficeListProps | any) => {
  const onSelected = (id) => {
    let updatedList = [...selected]
    if (!updatedList.includes(id)) {
      updatedList = [...selected, id]
    } else {
      const index = updatedList.indexOf(id)
      if (index > -1) {
        updatedList.splice(index, 1)
      }
    }
    setSelected(updatedList)
  }

  return (
    <div className=' bg-[#F4F4F4] shadow-[0px_0.5px_1.5px_0px_rgba(0,0,0,0.25)] cursor-pointer hover:bg-[#EBF3FF] rounded-[6px] md:p-[20px] p-[10px]'>
      <div className='grid grid-cols-[16px_auto] items-start md:gap-[20px] gap-[10px]'>
        <CheckboxField id={props.id} onClick={() => onSelected(props.id)} />
        <label className='' htmlFor={props.id}>
          <p className='mb-[29px] text-[#093269] md:text-[16px] text-[12px] font-medium '>
            Maurice Andrews Solicitors LTD
          </p>

          <div className='flex items-start gap-[7px]'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='w-[16px] h-[16px] mt-1'
              viewBox='0 0 17 17'
              fill='none'
            >
              <path
                d='M8.5 1.5C5.34799 1.5 2.5 3.79004 2.5 7.33537C2.5 9.59572 4.33756 12.259 8.00373 15.3251C8.28987 15.5583 8.7146 15.5583 9.00074 15.3251C12.6624 12.259 14.5 9.59996 14.5 7.33537C14.5 3.79004 11.652 1.5 8.5 1.5ZM8.5 8.61185C7.67288 8.61185 7.00224 7.97149 7.00224 7.19118C7.00224 6.41087 7.67735 5.7705 8.5 5.7705C9.32265 5.7705 9.99776 6.41087 9.99776 7.19118C9.99776 7.97149 9.32265 8.61185 8.5 8.61185Z'
                fill='#122D5C'
              />
            </svg>
            <div className='text-[#405985] md:text-[16px] text-[12px] font-normal '>
              60 Gracechurch Street
              <span className='block'> EC3V OHR, London, England</span>
            </div>
          </div>
          <div className='flex mt-[15px]  md:gap-[40px] gap-[10px]'>
            <div className='flex items-center gap-[7px]'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='17'
                height='17'
                viewBox='0 0 17 17'
                fill='none'
              >
                <path
                  d='M14.1919 11.6362C13.2413 10.8095 12.2765 10.3088 11.3375 11.1342L10.7768 11.6331C10.3666 11.9953 9.60382 13.6874 6.65479 10.2382C3.70637 6.7934 5.46093 6.25705 5.87178 5.89802L6.43555 5.3985C7.36963 4.57117 7.01712 3.52967 6.34343 2.45758L5.93688 1.80821C5.26011 0.738611 4.52316 0.0361628 3.58662 0.862242L3.08058 1.31181C2.66666 1.61839 1.50965 2.61493 1.22899 4.50811C0.891224 6.77967 1.95673 9.38091 4.39788 12.235C6.83596 15.0904 9.22306 16.5247 11.4843 16.4997C13.3635 16.4791 14.4984 15.4538 14.8534 15.081L15.3612 14.6309C16.2953 13.8054 15.715 12.965 14.7637 12.1364L14.1919 11.6362Z'
                  fill='#122D5C'
                />
              </svg>
              <p className='text-[#405985] md:text-[16px] text-[12px] font-normal '>
                020726 444 444
              </p>
            </div>
            <div className='flex items-center gap-[7px]'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='17'
                height='17'
                viewBox='0 0 17 17'
                fill='none'
              >
                <path
                  d='M13.3 4C13.9627 4 14.5 4.53726 14.5 5.2V11.875C14.5 12.4938 13.96 13 13.3 13H3.7C3.04 13 2.5 12.4938 2.5 11.875V5.2C2.5 4.53726 3.03726 4 3.7 4H13.3Z'
                  stroke='#122D5C'
                  stroke-width='1.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
                <path
                  d='M3 4.5L8.5 8.99967L14 4.5'
                  stroke='#122D5C'
                  stroke-width='1.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
              </svg>
              <p className='text-[#405985] md:text-[16px] text-[12px] font-normal'>
                email@gmail.com
              </p>
            </div>
          </div>
        </label>
      </div>
    </div>
  )
}
